export const bonusCustomName: string = 'Bonus';
